import React from "react";
import { cn } from "../../lib/utils";

const Switch = React.forwardRef(({ className, checked, onCheckedChange, ...props }, ref) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    className={cn(
      "relative inline-flex h-6 w-11 items-center rounded-full transition-colors",
      "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
      checked ? "bg-blue-600" : "bg-gray-200",
      className
    )}
    onClick={() => onCheckedChange(!checked)}
    ref={ref}
    {...props}
  >
    <span
      className={cn(
        "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
        checked ? "translate-x-6" : "translate-x-1",
        "rtl:translate-x-reverse"
      )}
    />
  </button>
));

Switch.displayName = "Switch";

export { Switch }; 